import { APICallV2Post } from '../APICall';

export class UnshareApiCall extends APICallV2Post {
    _method = 'folder/unshare';
}
